var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.55 14.55",
    fill: "#D50000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.34,13.34,8.28,7.28l6.06-6.07a.7.7,0,0,0,0-1,.7.7,0,0,0-1,0L7.28,6.27,1.21.21a.7.7,0,0,0-1,0,.7.7,0,0,0,0,1L6.27,7.28.21,13.34a.67.67,0,0,0-.21.5.71.71,0,0,0,.71.71.67.67,0,0,0,.5-.21L7.28,8.28l6.06,6.06a.7.7,0,0,0,1,0A.7.7,0,0,0,14.34,13.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.d6c27b974dee3a3c0d0b5b8050f0b5b3.svg";
export { ForwardRef as ReactComponent };